<template>
<div class="bottom-nav">

        <div class="col2">
            <small class="link button-text-white"><span @click="toggleMenu()">Menu</span></small>
        </div>

        <div>
            <small class="social">
                <span class="dark-grey">Follow</span>
                <a class="button-text-white" href="https://www.instagram.com/formation.network/" target="_blank">
                    <span>Instagram</span>
                </a>
                <a class="button-text-white" href="https://twitter.com/formation_fyi" target="_blank">
                    <span>Twitter</span>
                </a>
                <a class="button-text-white" href="https://communityinviter.com/apps/formation-fyi/formation" target="_blank">
                    <span>Slack (feedback)</span>
                </a>
            </small>
        </div>

        <div>            
            <p class="signed-out" v-if="!userinfo">
                <span class="button-text-white" @click="toggleLogin(); showSignUp('join');">Join</span>
                <span class="dark-grey">&nbsp;or&nbsp;</span>
                <span class="button-text-white" @click="toggleLogin(); showSignUp('login');">Login</span>
                <span class="dark-grey">&nbsp;/&nbsp;</span>
                <span class="button-text-white uppercase underline-button" @click="toggleCreatePost(); togglePopMess('You have to Login to Post')">Post Debate</span>
            </p>
            <p class="signed-in" v-if="userinfo">
                <span class="button-text-white" v-if="userinfo.firstname" @click="toggleLogin()">{{ userinfo.firstname }}</span>
                <span class="button-text-white" v-else @click="toggleLogin()">Profile</span>
                <span class="dark-grey">&nbsp;/&nbsp;</span>
                <span class="button-text-white uppercase underline-button" @click="toggleCreatePost()"><span>Post Debate</span></span>
            </p>
        </div>

</div>

</template>

<script>
import { db, auth } from '../db'

export default {
  name: 'BottomNav',
  props: [
    "userinfo"
  ],
  components: {
  },
  methods: {
    toggleMenu() {
      this.$store.commit('toggleMenu')
    },
    toggleCreatePost() {
      this.$store.commit('toggleCreatePost')
    },
    toggleLogin(payload) {
      this.$store.commit('toggleLogin', payload)
    },
    showSignUp(payload) {
      this.$store.commit('showSignUp', payload)
    },
    togglePopMess(payload) {
      this.$store.commit('togglePopMess', payload)
    },
  }
}
</script>
<style lang="scss" scoped>
// @import "../scss/_variables.scss";

.bottom-nav {
  position: fixed;
  z-index: 10;
  height: auto;
  width: 100vw;
  bottom: 0;
  padding: 0 $grid-padding;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  background-color: $black;
  div {
      display: flex;
      align-items: center;
      height: $nav-height;
      margin-bottom: 20px;
      &:last-child {
          margin-left: auto;
      }
  }
  .social {
      a {
          margin-left: $main-margin;
      }
  }
}

// MOBILE
@media #{$mobile} { 
  .bottom-nav {
    height: auto;
    padding: 0 $main-margin-mobile;
    div {
        height: $nav-height-mobile;
        margin-bottom: 20px;
        &:nth-child(2) {
            display: none;
        }
    }
  }
}

</style>